import {
  InboxPermissionLevel,
  IProject,
  IProjectUser,
  ISecurityGroup,
  IUser,
} from '../../api-client/autogenerated';

/**
 * Mirrors the backend's effective security group resolution: an explicit project security group
 * wins; otherwise a company-access user (user's company matches the subscriber's company) gets the
 * subscriber's company-view security group.
 */
export const getInboxPermissionLevel = (
  user: IUser,
  project: IProject,
  projectUser?: IProjectUser,
  companyViewSecurityGroup?: ISecurityGroup | null,
) => {
  let permission: InboxPermissionLevel | null = null;
  if (user.isSiteAdmin) {
    permission = InboxPermissionLevel.NUMBER_4;
  } else if (project.subscriberId === user.adminOfSubscriberId) {
    permission = InboxPermissionLevel.NUMBER_4;
  } else if (projectUser?.securityGroup) {
    permission = projectUser.securityGroup.correspondenceInboxPermission ?? null;
  } else if (isCompanyAccessUser(user, project)) {
    permission = companyViewSecurityGroup?.correspondenceInboxPermission ?? null;
  }
  return permission;
};

export const isCompanyAccessUser = (user: IUser, project: IProject) =>
  !!user.companyId &&
  !!project.subscriber?.companyId &&
  user.companyId === project.subscriber.companyId;
